import React from "react";
import ATLTinkerpreneurCTA from "./ATLTinkerpreneurCTA";

const ATLTinkerpreneurBanner = (props) => {
  const { year } = props;
  return (
    <div className="d-flex align-items-center flex-column">
      <img
        src={`images/ai-for-educator-${year}-banner.jpeg`}
        className="w-100"
        alt={`AI-for-educators ${year} banner`}
      />
      {localStorage.getItem("jwtToken") === null && (
        <ATLTinkerpreneurCTA year={year} />
      )}
    </div>
  );
};

export default ATLTinkerpreneurBanner;
